<app-slide-in-right-modal
  [slideOpen]="true"
  [returnPath]="returnPathUrl"
  (action)="closeModal()"
>
  <div class="flex flex-col items-center space-y-5 text-center">
    <span class="text-xl font-bold text-mango-black">{{ product.name }}</span>
    <img
      class="h-[127px] w-[163px]"
      src="/assets/images/svgs/bank-note.svg"
      alt="Bank notes"
    />
    <span class="text-lg font-semibold text-mango-black"
      >How much do you want to invest?</span
    >
    <span class="text-sm text-mango-gray74"
      >Consider market demand, investor preferences, and fund performance to
      decide the right amount</span
    >
  </div>

  <div class="mt-5 space-y-4 rounded-[15px] bg-mango-papayaWhip p-[15px]">
    <span>Product Information</span>
    <div class="flex justify-between">
      <span class="text-xs font-[350] text-mango-grey">Currency</span>
      <span class="text-sm font-extrabold tracking-[0.28px] text-mango-grey">
        {{ product?.currency | uppercase }}
      </span>
    </div>
    <div class="flex justify-between">
      <span class="text-xs font-[350] text-mango-grey">Unit Price:</span>
      <span class="text-sm font-extrabold tracking-[0.28px] text-mango-grey">
        {{ unitPrice | number: '1.0-0' }}
      </span>
    </div>
    <div class="flex justify-between">
      <span class="text-xs font-[350] text-mango-grey"
        >Units to be Purchased:</span
      >
      <span class="text-sm font-extrabold tracking-[0.28px] text-mango-grey">
        {{ unitsCalculated | number: '1.0-0' }}
      </span>
    </div>
  </div>

  <div class="page__container">
    <form
      class="form__container my-5 flex flex-col gap-5"
      [formGroup]="productOrderForm"
      (ngSubmit)="createOrder()"
    >
      <!-- Charge Source -->
      <div>
        <app-input-label
          labelFor="payment-source"
          labelClass="label--bottom-margin"
          >Charge Source</app-input-label
        >
        <select
          name="source"
          required
          base-select
          formControlName="payment_source"
        >
          <option value="wallet">Wallet</option>
          <option value="portfolio_cash">Cash in hand</option>
          <option value="direct_debit">Direct Debit</option>
        </select>
      </div> 

      <!-- When direct debit chosen and accounts exist show selection -->
      @if(productOrderForm.get('payment_source')?.value === 'direct_debit' && linkedDirectDebitAccounts.length > 0 ) {
        <div>
          <app-input-label
            labelFor="direct-debit-account"
            labelClass="label--bottom-margin"
            >Direct Debit Account</app-input-label
          >
          <select
            name="directDebitAccount"
            base-select
            formControlName="direct_debit_account_id"
          >
            <option value="" disabled selected>
              Choose an account
            </option>
            <option *ngFor="let acct of linkedDirectDebitAccounts" [value]="acct.id">
              {{ acct.account_name }}
            </option>
          </select>
        </div>
      }

      <div>
        <app-input-label labelFor="amount" labelClass="label--bottom-margin"
          >Subscription Amount</app-input-label
        >
        <app-input
          placeholder="Enter Amount"
          inputClass="input--padding"
          formControlName="amount"
          [(ngModel)]="amount"
          (ngModelChange)="updateUnits()"
        ></app-input>

        @if (productOrderForm.get('payment_source')?.value === 'wallet') {
          <div class="mt-1 text-sm">
            Balance:
            {{ '₦' }}{{
              reduceBalance(
                product?.currency === 'USD' ? (fxRateData?.naira_equivalent || 0) : productOrderForm.get('amount')?.value,
                (walletBalance$ | async) || 0 / 100
              ) | number: '1.0-2'
            }}
          </div>
        }
        @if (productOrderForm.get('payment_source')?.value === 'portfolio_cash') {
          <div class="mt-1 text-sm">
            Balance:
            {{ '₦' }}{{
              reduceBalance(
                product?.currency === 'USD' ? (fxRateData?.naira_equivalent || 0) : productOrderForm.get('amount')?.value,
                portfolioCash
              ) | number: '1.0-2'
            }}
          </div>
        }

        @if (fxRateData) {
          <div class="mt-2 space-y-4 rounded-[15px] bg-mango-papayaWhip p-[15px]">
            <span>Exchange Rate</span>
            <div class="flex justify-between">
              <span class="text-xs font-[350] text-mango-grey">Rate</span>
              <span class="text-sm font-extrabold tracking-[0.28px] text-mango-grey">1 USD = ₦{{ fxRateData.rate | number: '1.2-2' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-xs font-[350] text-mango-grey">NGN Equivalent</span>
              <span class="text-sm font-extrabold tracking-[0.28px] text-mango-grey">₦{{ fxRateData.naira_equivalent | number: '1.0-0' }}</span>
            </div>
          </div>
        }
      </div>

      <button
        mango-button
        [loading]="(loading$ | async) || productOrderForm.invalid"
        [disabled]="(loading$ | async) || productOrderForm.invalid || (product?.currency === 'USD' && !fxRateData)"
        (click)="createOrder()"
        class="submit-button"
      >
        <span *ngIf="loading$ | async" spin></span>
        @if (!(loading$ | async)) {
          Purchase
        }
      </button>
    </form>
    <!-- <p>Form Valid: {{ productOrderForm.valid }}</p> -->
    <!-- <p>Amount Control Valid: {{ productOrderForm.get('amount')?.valid }}</p> -->
    <!-- <p>Unit Control Valid: {{ productOrderForm.get('unit')?.valid }}</p> -->
  </div>
</app-slide-in-right-modal>
